import { BottomSheet } from "components/BottomSheet";
import { DatePickerNew } from "components/DatePickerNew";
import { FormProvider } from "react-hook-form";
import { SheetPrimaryButton, SheetSecondaryButton } from "./SheetActions";
import { UpdateDepartureLogicRetVal } from "./useUpdateDepartureLogic";

type Props = {
  logic: UpdateDepartureLogicRetVal;
};

export const OperatorDepartureSheet = ({ logic }: Props) => (
  <BottomSheet
    isOpen={logic.isModalOpen}
    onClose={logic.onModalClose}
    title="Avfärd"
  >
    <FormProvider {...logic.form}>
      <form className="space-y-6 pb-2" onSubmit={logic.onSubmit}>
        <div className="inline-block">
          <DatePickerNew name="timeOfDepartureUtc" label="Datum för avfärd" />
        </div>

        <div className="flex gap-x-3 border-t border-gray-75 pt-4">
          <SheetSecondaryButton onClick={logic.onModalClose} />
          <SheetPrimaryButton isLoading={logic.isPending}>
            Spara
          </SheetPrimaryButton>
        </div>
      </form>
    </FormProvider>
  </BottomSheet>
);
